import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  buttonContainer: { flex: 1, marginTop: 30 },

  container: { height: "100%", margin: 10 },
  loginButton: { marginBottom: 20 },
  mt30: { marginVertical: 30 },
  phoneNumberInputContainer: { alignSelf: "center", marginTop: 0 },
  phoneNumberInputStyle: {
    height: 40,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  titleText: { fontFamily: typography.primary.normal, fontSize: 23, marginBottom: 10 },
  inputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  inputContainer: { alignSelf: "center", marginTop: 10 },
})
